import { useState } from "react";
import { Eraser, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Section } from "@/components/settings/Section";

export function WipeData({ t, input, open, onToggle }) {
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const ready = pwd && confirm.trim().toUpperCase() === "WYCZYŚĆ";
  const wipe = async () => {
    if (!window.confirm(t("Na pewno usunąć wszystkie wprowadzone dane? Tego nie da się cofnąć poza przywróceniem kopii."))) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/wipe-data", { password: pwd, confirm });
      toast.success(`${t("Baza wyczyszczona")} (${data.dropped}). ${t("Kopia przed czyszczeniem")}: ${data.backup}`);
      setTimeout(() => window.location.reload(), 1500);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Section icon={Eraser} iconColor="text-red-400" title={t("Wyczyść całą bazę danych")} open={open} onToggle={onToggle} testid="settings-sec-wipe">
      <div className="space-y-2 text-xs">
        <p className="text-slate-300">{t("Usuwa wszystkie wprowadzone dane: sieć, kable, mufy, klientów, faktury, zgłoszenia, zadania, WiFi, czat i historię.")}</p>
        <p className="text-emerald-300/90">{t("Zostają: konta i hasła, licencja i aktywacja, ustawienia programu, katalogi, baza TERYT oraz kopie zapasowe.")}</p>
        <p className="text-amber-300/90">{t("Przed czyszczeniem program sam zrobi kopię danych — znajdziesz ją na liście kopii zapasowych.")}</p>
        <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder={t("Twoje hasło")} data-testid="wipe-password" className={input} />
        <input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder={t("Wpisz: WYCZYŚĆ")} data-testid="wipe-confirm" className={input} />
        <button onClick={wipe} disabled={!ready || busy} data-testid="wipe-submit"
          className="w-full bg-red-700 hover:bg-red-600 rounded py-2 text-sm flex items-center justify-center gap-2 disabled:opacity-50 transition-colors">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Eraser size={15} />} {t("Wyczyść całą bazę danych")}
        </button>
      </div>
    </Section>
  );
}
